import { Navigate } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";
import { isVerifiedUser } from "../firebase/sso";

export default function PrivateRoute({ children }) {
  const { authIsReady, user } = useAuthContext();

  if (!authIsReady) {
    // Or return some loading indicator/spinner
    return null;
  }

  if (!isVerifiedUser(user)) {
    return <Navigate to="/login" />;
  }

  return children; // Render the protected page/layout
}